import React, { useEffect, useState } from 'react'
import { ListH2, StyledSubtitle } from '../style'
import List from '@components/List'
import { A } from '@components/Button/index'
import { deepClone } from '@utils'
import { useLocale } from '@hooks'
import { nodeLocaleToEnglishLanguage } from '../../../../gatsby/createPagesUtils/nodeHelpers'
import { LIST_QUERY } from '../../../apollo/queries/contentful.apollo.queries'
import { useQuery } from '@apollo/client'
import { DotListTextContainer } from '@components/List/style'

const StyledPreviewList = ({ listAppearance, linkId, listItemsCollection }) => {
  const { locale } = useLocale()
  const [data, setData] = useState(null)

  const { loading, data: previewData } = useQuery(LIST_QUERY, {
    variables: { id: linkId },
    skip: !linkId,
  })

  useEffect(() => {
    if (previewData) setData(deepClone(previewData))
  }, [previewData])

  const us = 'en-US'
  let loc = locale === 'enGB' ? 'en-GB' : locale === 'en' ? us : locale
  const display = linksTo => {
    const localizedLinksTo = linksTo
    let { displayOnSites } = localizedLinksTo
    return (
      !displayOnSites ||
      displayOnSites?.includes(nodeLocaleToEnglishLanguage[loc])
    )
  }
  const list =
    listItemsCollection?.items || data?.list?.listItemsCollection?.items

  if (!loading && list) {
    if (listAppearance === 'Bordered List') {
      return (
        <List timeline width="100%">
          {list?.map(({ title, subtitle, linksToCollection }, i) => {
            const linksTo = linksToCollection?.items?.[0]
            return (
              <div key={`list-item-${i + 1}`}>
                {linksTo && display(linksTo) ? (
                  <DotListTextContainer>
                    <A
                      to={linksTo?.slug}
                      contentType={linksTo?.__typename}
                      category={linksTo?.category?.slug}
                    >
                      <ListH2
                        textCase="default"
                        color="#5A3462"
                        fontSize="18px"
                        margin="0px"
                        noDivider
                        underline
                        padding="0px"
                        letterSpacing="normal"
                        style={{ textAlign: 'left' }}
                      >
                        {title}
                      </ListH2>
                    </A>
                    {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
                  </DotListTextContainer>
                ) : (
                  <DotListTextContainer>
                    <ListH2
                      textCase="default"
                      color="#5A3462"
                      fontSize="18px"
                      margin="0px"
                      noDivider
                      underline
                      padding="0px"
                      letterSpacing="normal"
                      style={{ pointerEvents: 'none' }}
                    >
                      {title}
                    </ListH2>
                    {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
                  </DotListTextContainer>
                )}
              </div>
            )
          })}
        </List>
      )
    }
  }
  return null
}

const StyledList = ({
  fields,
  preview,
  listItems,
  listAppearance,
  linksTo,
  linkId,
}) => {
  const { locale } = useLocale()

  if (preview) return <StyledPreviewList {...fields} listId={linkId} />

  const us = 'en-US'
  let loc = locale === 'enGB' ? 'en-GB' : locale === 'en' ? us : locale
  const display = linksTo => {
    let { displayOnSites } = linksTo
    return (
      !displayOnSites ||
      displayOnSites?.includes(nodeLocaleToEnglishLanguage[loc])
    )
  }
  if (listAppearance === 'Bordered List') {
    return (
      <List timeline width="100%">
        {listItems?.map(({ title, subtitle, linksTo }, i) => (
          <div key={`list-item-${i + 1}`}>
            {linksTo && display(linksTo[0]) ? (
              <DotListTextContainer>
                <A
                  to={linksTo?.[0]?.slug}
                  contentType={linksTo?.[0]?.__typename}
                  category={linksTo?.[0]?.category?.slug}
                >
                  <ListH2
                    textCase="default"
                    color="#5A3462"
                    fontSize="18px"
                    margin="0px"
                    noDivider
                    underline
                    padding="0px"
                    letterSpacing="normal"
                    style={{ textAlign: 'left' }}
                  >
                    {title?.listText}
                  </ListH2>
                </A>
                {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
              </DotListTextContainer>
            ) : (
              <DotListTextContainer>
                <ListH2
                  textCase="default"
                  color="#5A3462"
                  fontSize="18px"
                  margin="0px"
                  noDivider
                  underline
                  padding="0px"
                  letterSpacing="normal"
                  style={{ pointerEvents: 'none' }}
                >
                  {title?.listText}
                </ListH2>
                {subtitle && <StyledSubtitle>{subtitle}</StyledSubtitle>}
              </DotListTextContainer>
            )}
          </div>
        ))}
      </List>
    )
  }

  return null
}

export default StyledList
